import { fireEvent, registerEventListener, unregisterEventListener } from '@/events/helpers'
import { useAuthStore } from '@/stores/auth'
import { identifyUserEvent } from '@/utils/account'
import { pushToDataLayer } from '@/utils/gtm'
import { datadogRum } from '@datadog/browser-rum'
import { isEmpty } from 'lodash-es'

export default defineNuxtPlugin((nuxtApp) => {
  // Set up router navigation tracking
  nuxtApp.$router?.afterEach((to, from) => {
    const isQueryOnlyUpdate =
      to.path === from.path && to.hash === from.hash && to.fullPath !== from.fullPath

    if (isQueryOnlyUpdate) {
      return
    }

    const authStore = useAuthStore()
    const otaUserId = authStore.user?.user?._id ?? ''

    setTimeout(() => {
      pushToDataLayer({
        event: 'pageView'
      })

      pushToDataLayer({
        event: 'custom_page_load'
      })

      if (otaUserId) {
        identifyUserEvent({ otaUserId: `${otaUserId}` })

        try {
          const datadogUser = datadogRum.getUser()

          if (isEmpty(datadogUser)) {
            datadogRum.setUser({
              id: `${otaUserId}`,
              country: authStore.user?.user?.country?.name.toLowerCase() ?? ''
            })
          }
        } catch (_error) {
          console.error('Error setting user in Datadog', _error)
        }
      }
    }, 2000)
  })

  // Add global properties to the Vue app
  const gp = nuxtApp.vueApp?.config?.globalProperties
  if (gp) {
    gp.$fireEvent = fireEvent
    gp.$registerEventListener = registerEventListener
    gp.$unregisterEventListener = unregisterEventListener
  }
})
